export const COLUMNS = [
  {
    Header: "Type",
    accessor: "fileType"
  },
  {
    Header: "View",
    accessor: "viewType"
  },
  {
    Header: "Period",
    accessor: "periodCount"
  },
  {
    Header: "Filters",
    accessor: "iso2CountryCode"
  },
  {
    Header: "Status",
    accessor: "dataStatus"
  },
  {
    Header: "Generated on",
    accessor: "completedAt"
  }
];
